import { mode } from '@chakra-ui/theme-tools';

const baseStyles = (props) => ({
  color: mode('black', 'white')(props),
  _hover: {
    background: 'linear-gradient(180deg, #2ABDFD 0%, #0497FD 100%)',
    'background-clip': 'text',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
    textDecoration: 'underline',
  },
  _focus: {
    boxShadow: 'none',
  }
});

const titleBaseStyles = (props) => ({
  ...baseStyles(props),
  fontWeight: '600',
});

const textBaseStyles = (props) => ({
  ...baseStyles(props),
  fontWeight: '400',
});

export const linkStyles = {
  components: {
    Link: {
      decoration: 'none',
      baseStyle: (props) => ({
        ...baseStyles(props),
        fontSize: '16px'
      }),
      variants: {
        'title-lg': (props) => ({
          ...titleBaseStyles(props),
          fontSize: '18px',
        }),
        'title-md': (props) => ({
          ...titleBaseStyles(props),
          fontSize: '16px',
        }),
        'title-sm': (props) => ({
          ...titleBaseStyles(props),
          fontSize: '14px',
        }),
        'text-lg': (props) => ({
          ...textBaseStyles(props),
          fontSize: '18px',
        }),
        'text-md': (props) => ({
          ...textBaseStyles(props),
          fontSize: '16px',
        }),
        'text-sm': (props) => ({
          ...textBaseStyles(props),
          fontSize: '14px',
        }),
        'text-xs': (props) => ({
          ...textBaseStyles(props),
          fontSize: '12px',
        }),
      }
    }
  },
};
